<template>
    <el-popover placement="bottom" trigger="click" :auto-close="0" :width="400">
        <el-radio-group v-model="type" size="mini" @change="changedDate">
            <el-radio-button label="1">天</el-radio-button>
            <el-radio-button label="2">周</el-radio-button>
            <el-radio-button label="3">月</el-radio-button>
            <el-radio-button label="4">年</el-radio-button>
            <el-radio-button label="5">自定义</el-radio-button>
        </el-radio-group>
        <!-- <br />
        <br /> -->
        <el-date-picker v-model="begin" v-if="type == 1" size="small" type="date" placeholder="选择日期"> </el-date-picker>
        <el-date-picker v-model="week" v-if="type == 2" @change="changedWeek" size="small" type="week" format="gggg 第 ww 周" placeholder="选择周">
        </el-date-picker>
        <el-date-picker v-model="month" v-if="type == 3" size="small" type="month" placeholder="选择月"> </el-date-picker>
        <el-date-picker v-model="year" v-if="type == 4" size="small" type="year" placeholder="选择年"> </el-date-picker>
        <el-date-picker v-model="range" v-if="type == 5" type="daterange" size="small" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <!-- <br />
        <br /> -->
        <el-button type="primary">确定</el-button>
        <el-button plain>关闭</el-button>
        <template v-slot:reference>
            <span>日期：{{ text }}</span>
            <div class="button-icon icon-shop button-icon-checked" @click="showDialog">实体</div>
        </template>
    </el-popover>
</template>
<script>
export default {
    name: "DatePicker",
    data() {
        return {
            type: "1",
            begin: "",
            end: "",
            text: "",
            week: "",
            month: "",
            year: "",
            range: [],
        };
    },
    created() {
        this.text = new Date().format("yyyy-MM-dd");
    },
};
</script>
